<template>
    <section v-if="blok" v-editable="blok" class="apr-section coupon-code-section">
        <div class="container px-4 xl:px-0 mx-auto">
            <h2 class="coupon-code-section__title">{{ blok.title }}</h2>
            <div class="coupon-code-section__btn">
                <button class="copy-btn" @click="copy(source)">
                    <span class="copy-btn__text">
                        {{ copied ? 'Code is copied to clipboard' : blok.code }}
                    </span>
                    <span v-if="isSupported" class="copy-input__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path
                                d="M7.4998 6V3C7.4998 2.44772 7.94752 2 8.4998 2H20.4998C21.0521 2 21.4998 2.44772 21.4998 3V17C21.4998 17.5523 21.0521 18 20.4998 18H17.4998V20.9991C17.4998 21.5519 17.0499 22 16.493 22H4.50666C3.95059 22 3.5 21.5554 3.5 20.9991L3.5026 7.00087C3.5027 6.44811 3.95264 6 4.50942 6H7.4998ZM5.50242 8L5.50019 20H15.4998V8H5.50242ZM9.4998 6H17.4998V16H19.4998V4H9.4998V6Z"
                                fill="#0E242B"
                            />
                        </svg>
                    </span>
                </button>
            </div>
            <div v-if="!emailSubscriptionStore.isSubscribed && blok.subscribeForm[0]" class="coupon-code-section__form">
                <EmailSubscription class="" :blok="blok.subscribeForm[0]" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { IAprCouponCodeSection } from '~/../types/AprCouponCodeSection';
const { blok } = defineProps<{ blok: IAprCouponCodeSection }>();

// Email subscription
import { useEmailSubscriptionStore } from '@nuxt-monorepo/base/app/store/emailSubscription';
const emailSubscriptionStore = useEmailSubscriptionStore();
import EmailSubscription from '../../storyblok/EmailSubscription.vue';

// Clipboard
import { useClipboard } from '@vueuse/core';
const source = ref(blok.code);
const { copy, copied, isSupported } = useClipboard({ source });
</script>

<style lang="postcss" scoped>
.apr-section {
    @apply py-4;
}
.coupon-code-section {
    &__title {
        @apply text-xl sm:text-2xl leading-6 lg:text-[2.5rem] lg:leading-[3rem] text-center uppercase font-bold mb-4;
    }
    &__btn {
        @apply text-center;
    }
    &__form {
        @apply mt-4;
        :deep(#SbEmailSubscription) {
            @apply bg-transparent py-0 my-0 px-0;
            .container {
                p {
                    @apply hidden;
                }
                h3 {
                    @apply text-text-primary-asphalt font-normal text-base lg:text-xl normal-case mb-4 lg:mb-8;
                }
            }
            .success {
                @apply text-text-primary-asphalt;
            }
            .input-wrapper {
                @apply pt-0;
            }
        }
    }
}

.copy-btn {
    @apply w-full sm:w-auto p-4 inline-flex items-center border border-dashed border-brand-primary-500 rounded-lg text-brand-primary-500;
    &__text {
        @apply text-center  grow sm:w-80 lg:w-[500px];
    }
}
</style>
